import School from '../models/School';
import { useSchoolList } from './schoolList';

// Distinct from useHSSchools' key: that hook fetches high schools only, and
// the two used to share one key and overwrite each other. Versioned so no
// pre-split cache is ever read.
const CACHE_KEY = 'schools:customer:v1';

// Module scope keeps the identity stable for useSchoolList's effect deps.
const buildScope = () => School
  .where({ sales_stat: { eq: ['CUST', 'XCUST', 'NCUST'] } })
  .order({ name: 'asc' });

const useSchools = () => useSchoolList(CACHE_KEY, buildScope);

export default useSchools;
